const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

function subscribe(eventName, callback) {
  if (!window[eventName]) {
    window[eventName] = [];
  }

  window[eventName] = [...window[eventName]];
  window[eventName].push(callback);

  return function unsubscribe() {
    window[eventName] = window[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (window[eventName]) {
    window[eventName].forEach((callback) => {
      callback(data);
    });
  }
}